module.exports = __webpack_public_path__ + "static/media/MS-Sans-Serif.b57e2636.woff2";